import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { backendGet } from "../../services/dataService.js";
import { Typography } from "@mui/material";
import { getDatumZeit } from "../../services/formatService.js";
import PropTypes from "prop-types";
import {
  ContentDialog,
  ContentDialogInit,
} from "components/MDDForm/components/ContentDialog.jsx";
import DataTable from "../DataTable.jsx";
import ClaimStatusBadge from "../ClaimStatusBadge.jsx"; // ggf. Pfad anpassen

const ClaimStatusHistoryModal = ({ open, onClose, claimId }) => {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { setOpenCD, tca, setTca } = ContentDialogInit();

  // initialize dialog content with empty history and loading state
  useEffect(() => {
    showHistory();
  }, []);

  // fetch history when modal opens
  useEffect(() => {
    if (open) {
      fetchHistory();
    }
  }, [open, claimId]);

  // update dialog content when history changes
  useEffect(() => {
    if (open) {
      showHistory();
    }
  }, [history]);

  const columns = [
    {
      accessorKey: "timestamp",
      header: "Datum",
      Cell: ({ cell }) => getDatumZeit(cell.getValue()),
    },
    {
      accessorKey: "status.label",
      header: "Status",
      Cell: ({ row }) => (
        <ClaimStatusBadge
          status={row.original.status?.value}
          label={row.original.status?.label}
          size="small"
        />
      ),
    },
    {
      accessorKey: "user",
      header: "Verantwortlicher",
      Cell: ({ row }) =>
        `${row.original.user.vorname} ${row.original.user.nachname}`,
    },
  ];

  const fetchHistory = async () => {
    try {
      const response = await backendGet(`data/schadens/${claimId}/history`, {
        label: "Status-Historie abrufen",
        setIsLoading,
        enqueueSnackbar,
      });
      setHistory(response.data);
    } catch (error) {
      console.error("Fehler beim Abrufen der Historie:", error);
    }
  };

  const showHistory = () => {
    setTca({
      title: "Status-Historie",
      maxWidth: "md",
      content: (
        <>
          {isLoading && (
            <Typography variant="body2">Lade Historie...</Typography>
          )}
          <DataTable
            columns={columns}
            data={history}
            isLoading={isLoading}
            enableTopToolbar={false}
            enableBottomToolbar={false}
            enableColumnFilters={false}
            enableSorting={false}
            enableFooter={false}
            enableHeader={true}
          />
        </>
      ),
      actions: null,
    });
  };

  return (
    <ContentDialog
      openCD={open}
      setOpenCD={setOpenCD}
      tca={tca}
      onClose={onClose}
    />
  );
};

ClaimStatusHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  claimId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ClaimStatusHistoryModal;
